import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core'
import AsterTypography from '../../../asterX-UI/Typography/AsterTypography'
import AsterButton from '../../../asterX-UI/Buttons/AsterButton'
import { useHomeStoreRop } from '../../../context/HomeStore/Rop'
import { useStyles } from './rop-tasks-filter.styles'
import MaskedTextInput from '../../../asterX-UI/Inputs/MackedTextInput'
import { AutoCompleteField } from '../../../asterX-UI/Inputs'
import { EVENT_TYPE, EVENT_TYPE_FILTER } from '../../../constants/events'
import { KeyboardDatePicker } from '@material-ui/pickers'
import DateIcon from '../../../asterX-UI/Icons/DateIcon'
import React from 'react'

export const RopTasksFilter = () => {
  const classes = useStyles()

  const {
    homeStore: {
      branches,
      managers,
      subdivisions,
      tasksFilter,
      selectedBranch,
      selectedMng,
      selectedSubdivision
    },
    homeStoreFunc: {
      handleTasksFilter,
      handleTaskDateChange,
      handleClearTaskFilter,
      getTasksList,
      setSelectedMng,
      setSelectedBranch,
      setSelectedSubdivision
    }
  } = useHomeStoreRop()

  return (
    <Grid item container>
      <Grid item container spacing={4} className={classes.filter}>
        <Grid item xs={12}>
          <AsterTypography variant="h6">Фильтр</AsterTypography>
        </Grid>
        <Grid item container spacing={3}>
          <Grid item xs={6} md={4} lg={3}>
            <TextField
              name="dealId"
              value={tasksFilter.dealId}
              onChange={handleTasksFilter}
              fullWidth
              label="Номер рабочего листа"
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <TextField
              name="firstName"
              value={tasksFilter.firstName}
              onChange={handleTasksFilter}
              fullWidth
              label="Имя Клиента"
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <MaskedTextInput
              name="phoneNumber"
              value={tasksFilter.phoneNumber}
              onChange={handleTasksFilter}
              mask="+7 (999) 999-99-99"
              fullWidth
              label="Номер телефона клиента"
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <FormControl fullWidth>
              <InputLabel id="statusTypes">Тип задачи</InputLabel>
              <Select
                labelId="statusTypes"
                fullWidth
                value={tasksFilter.statusCodes}
                onChange={handleTasksFilter}
                multiple
                name={'statusCodes'}
                renderValue={value =>
                  value?.length > 0
                    ? `${
                        EVENT_TYPE_FILTER?.find(v => v.code === value[0])?.name
                      } ${value.length > 1 ? '+' + (value.length - 1) : ''}`
                    : ''
                }
              >
                {EVENT_TYPE_FILTER?.map(v => (
                  <MenuItem key={v.code} value={v.code}>
                    <Checkbox
                      color={'primary'}
                      checked={tasksFilter.statusCodes.indexOf(v.code) > -1}
                    />
                    <ListItemText primary={v.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <AutoCompleteField
              value={selectedMng}
              onChange={({ target: { value } }) => setSelectedMng(value)}
              fullWidth
              label="Менеджер"
              labelKey="fullName"
              name="managers"
              valueKey={'username'}
              options={managers}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <AutoCompleteField
              value={selectedBranch || ''}
              onChange={({ target: { value } }) => setSelectedBranch(value)}
              fullWidth
              label="Филиал"
              name="branchCode"
              valueKey={'code'}
              options={branches}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd.MM.yyyy"
              label="Срок от"
              name="startDate"
              value={tasksFilter.startDate}
              onChange={val => handleTaskDateChange(val, 'startDate')}
              keyboardIcon={<DateIcon />}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd.MM.yyyy"
              label="Срок до"
              name="endDate"
              value={tasksFilter.endDate}
              onChange={val => handleTaskDateChange(val, 'endDate')}
              keyboardIcon={<DateIcon />}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <AutoCompleteField
              value={selectedSubdivision || ''}
              fullWidth
              label="Звено"
              name="subdivision"
              labelKey="rop"
              onChange={({ target: { value } }) =>
                setSelectedSubdivision(value)
              }
              options={subdivisions}
            />
          </Grid>
        </Grid>

        <Grid
          item
          container
          alignItems="center"
          justifyContent="space-between"
          className={classes.fixedBtns}
        >
          <Grid item>
            <FormControlLabel
              value={tasksFilter.expired}
              label="Просроченные"
              name="expired"
              control={<Checkbox color="primary" />}
              onChange={handleTasksFilter}
              className={classes.checkbox}
            />
          </Grid>
          <Grid item style={{ marginLeft: 'auto', marginRight: 10 }}>
            <AsterButton onClick={handleClearTaskFilter}>Сбросить</AsterButton>
          </Grid>
          <Grid item>
            <AsterButton color="primary" onClick={getTasksList}>
              Показать результаты
            </AsterButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
